import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { getHotelReceipt } from "../../components/ReceiptTemplates";
import { ReceiptData } from "../../types/print-setting";

type Props = {
  sample: ReceiptData;
  onClose: () => void;
};

export default function ReceiptModal({ sample, onClose }: Props) {
  const [receiptElement, setReceiptElement] = useState<JSX.Element | null>(null);

  useEffect(() => {
    (async () => {
      const r = await getHotelReceipt(sample);
      setReceiptElement(r);
    })();
  }, [sample]);

  const handlePrint = () => {
    if (!receiptElement) return;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    if (!printWindow) return;

    const styles = Array.from(document.querySelectorAll("link[rel=stylesheet], style"))
      .map((el) => el.outerHTML)
      .join("");

    printWindow.document.write('<html><head><title>Receipt</title>' + styles + '</head><body>');
    printWindow.document.write(
      `<div id="receipt-root">${document.getElementById("receipt-preview")?.innerHTML}</div>`
    );
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg relative flex flex-col">
        {/* Close X */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
          onClick={onClose}
        >
          {FaTimes({ size: 20 })}
        </button>

        {/* Scrollable Receipt */}
        <div className="p-4 max-h-[70vh] overflow-auto" id="receipt-preview">
          {receiptElement || <p>Loading receipt...</p>}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-end space-x-3 p-4 bg-white">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handlePrint}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Print Receipt
          </button>
        </div>
      </div>
    </div>
  );
}